import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ProductCategoryModel } from 'src/app/models/wardrobe.model';
import { WardrobeService } from './../../../services/wardrobe.service';

@Component({
  selector: 'shc-categories',
  templateUrl: './categories.page.html',
  styleUrls: ['./categories.page.scss'],
})
export class CategoriesPage implements OnInit {
  mainCategories: ProductCategoryModel[] = [];
  subCategoriesByParent: { [parentId: number]: ProductCategoryModel[] } = {};

  constructor(
    private router: Router,
    private wardrobeService: WardrobeService
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {
    this.getAllCategories();
  }

  getAllCategories() {
    this.wardrobeService.mainCategoriesList({ page: 1, per_page: 50 }).subscribe(res => {
      const allCategories = res.data;

      this.mainCategories = allCategories.filter(category => !category.parent_id);

      this.subCategoriesByParent = {};
      allCategories
        .filter(category => !!category.parent_id)
        .forEach(category => {
          if (!this.subCategoriesByParent[category.parent_id]) {
            this.subCategoriesByParent[category.parent_id] = [];
          }
          this.subCategoriesByParent[category.parent_id].push(category);
        });
    });
  }

  routeToCategory(id: number) {
    this.router.navigate(['categories', 'detail', id]);
  }

}
